/** 45 → "45 s" · 754 → "12 min" · 3900 → "1 h 05". Sem valor → "—". */
export function formatarDuracao(segundos) {
  if (segundos === null || segundos === undefined) return "—";
  if (segundos < 60) return `${segundos} s`;
  const min = Math.round(segundos / 60);
  if (min < 60) return `${min} min`;
  return `${Math.floor(min / 60)} h ${String(min % 60).padStart(2, "0")}`;
}
